import React, { useState, useMemo, useCallback, useContext } from "react";
import { Link } from "react-router";
import SupervisorApi from "../../utility/supervisorApi";
import { useQuery } from "@tanstack/react-query";
import debounce from "lodash-es/debounce";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import StoreManagementPerformance from "./StoreManagementPerformance";
import EditStore from "./EditStore";
import { formatNumbersWithDecimal } from "../../components/formatNumbersWIthDecimal";
import { formatNumbers } from "../../components/formatNumbers";
import { SupervisorCurrencyContext } from "../../context/SupervisorCurrencyProvider";

function StoreManagement() {
  const { currencyDetails } = useContext(SupervisorCurrencyContext);
  const { fetchData } = SupervisorApi();

  const [searched, setSearched] = useState("");
  const [store, setStore] = useState(null);
  const [viewGraph, setViewGraph] = useState(false);
  const debouncedSearch = useMemo(
    () =>
      debounce((search) => {
        setSearched(search);
      }, 500),
    []
  );

  const { data } = useQuery({
    queryKey: ["allStores", { searched }],
    queryFn: () => fetchData("/store-management", 1, searched),
    retry: 1,
    keepPreviousData: true,
    staleTime: 30 * 60 * 1000,
    cacheTime: 60 * 60 * 1000,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  const handleSearchChange = useCallback(
    (e) => {
      const value = e.target.value;
      setSearched(value);
      debouncedSearch(value);
    },
    [setSearched, debouncedSearch]
  );

  const handleClick = (id) => {
    setStore(id);
    setViewGraph(true);
  };

  return (
    <div className="min-w-full h-screen overflow-y-auto">
      <section class="m-4 ">
        <div class="flex justify-between items-center mb-4">
          <h2 class="text-2xl font-semibold ">Store Management</h2>
          <Link
            to="../addstore"
            class="bg-black text-white px-4 py-2 rounded hover:bg-gray-950"
          >
            + Add new store
          </Link>
        </div>
        <div class="bg-white p-4 rounded mb-2 shadow">
          <div class="flex items-center justify-between mb-4 ">
            <input
              class="flex flex-grow p-2 border rounded"
              placeholder="Search"
              type="text"
              value={searched}
              onChange={handleSearchChange}
              className="border-2 rounded-sm border-gray-400 w-60 p-1.5 px-4"
            />
            {/* <button class="ml-2 hover:cursor-pointer border-black border px-4 py-2 rounded">
              Filter
            </button> */}
          </div>
          {/* Use that of dashboard content */}
          <table class="w-full text-left">
            <thead className="bg-gray-300">
              <tr class="border-b">
                <th class="py-2 px-4 border-b text-center border-gray-300 text-wrap">
                  Store name
                </th>
                <th class="py-2 px-4 border-b text-center border-gray-300 text-wrap">
                  Location
                </th>
                <th class="py-2 px-4 border-b text-center border-gray-300 text-wrap">
                  Top product
                </th>
                <th class="py-2 px-4 border-b text-center border-gray-300 text-wrap">
                  Revenue
                </th>
                <th class="py-2 px-4 border-b text-center border-gray-300 text-wrap">
                  Total stock
                </th>
                <th class="py-2 px-4 border-b text-center border-gray-300 text-wrap">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {data?.map((item, index) => (
                <tr
                  key={item?.id}
                  className="cursor-pointer hover:bg-gray-200 "
                >
                  <td className="border-b py-2 px-4 text-center flex items-center gap-2">
                    <div
                      className="w-3 h-3 rounded-full"
                      style={{ backgroundColor: item?.color_code }}
                    ></div>
                    {item?.storeName}
                  </td>
                  <td className=" border-b py-2 px-4 text-center text-wrap">
                    {item?.location}
                  </td>
                  <td className=" border-b py-2 px-4 text-center text-wrap">
                    {item?.topProduct?.product_name}
                  </td>

                  <td className=" border-b py-2 px-4 text-center text-wrap">
                    {currencyDetails}
                    {formatNumbersWithDecimal(item?.totalRevenue)}
                  </td>
                  <td className="border-b py-2 px-4 text-center text-wrap">
                    {formatNumbers(item?.totalStock)}
                  </td>
                  <td className="border-b py-2 px-4 text-center  items-center">
                    <div className="flex justify-around items-center">
                      <EditStore item={item} />
                      <VisibilityIcon
                        className="text-yellow-500"
                        onClick={() => handleClick(item.id)}
                      />
                      <DeleteIcon
                        // onClick={() => handleDelete(item.id)}
                        className="text-red-500 cursor-pointer"
                      />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
      <section className="m-4 mt-0">
        <StoreManagementPerformance viewGraph={viewGraph} storeId={store} />
      </section>
    </div>
  );
}

export default StoreManagement;
